export const TOOGLE_MODAL = 'TOGGLE_MODAL';
export const SET_FILTER = 'SET_FILTER';
export const STOP_HANDLE = 'STOP_HANDLE';
export const CLEAR_FILTER = 'CLEAR_FILTER';